import { Component, Output, SimpleChange } from '@angular/core';
import { BaseUpdateBComponent } from '../../../libraries/base/update/base-update.bcomponent';
import { NewsRestService } from '../news-rest.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-news-update',
  templateUrl: 'news-update.component.html'
})
export class NewsUpdateComponent extends BaseUpdateBComponent {
  constructor(private _newsRest: NewsRestService) {
    super();
    this.componentId = 'NewsUpdateComponent';
    this.routeURL = '/news';
    this.entrySuccessI18n = 'success.news.update';
    this.headerTitle = 'ui.news.update.title';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'load',
      handle: () => {
        return this._newsRest.load(this.comp.routeParams.id).pipe(
          switchMap(doc => {
            if (doc.mainImage) {
              doc.mainImage.id = doc?.mainImage?._id;
            }

            return of(doc);
          })
        );
      },

      wrapRetryableTask: true,
      wrapLoadingComponentIds: this.componentId,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'save',
      handle: () => {
        const formValue = this.form.value;

        return this._newsRest.update(this.comp.routeParams.id, formValue);
      },

      wrapRetryableTask: true,
      wrapLoadingComponentIds: this.componentId,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () =>
        this.page.compHookService.callMultipleHooks([
          'NewsFormComponent:workflowBuildForm',
          'NewsUpdateComponent:workflowLoadData'
        ])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }
}
